<p-panel [toggleable]="true" class="m-0 p-0">
  <ng-template #header
    ><div><i class="pi pi-gauge mr-3"></i>Energy Meter Gauges</div></ng-template
  >
  <div class="flex justify-around flex-wrap knob">
    @for(EM of energyMeterList(); track EM.ID;) {
    <div
      class="flex flex-col items-center gap-1"
      [style]="
        iconsStyles.getOpacityStyle(
          customFunctions.getDeviceStatus(EM.available, EM.error)
        )
      "
    >
      <p-knob
        [size]="130"
        readonly="true"
        [valueTemplate]="getValueTemplate(EM.W)"
        [min]="0"
        [max]="getMaxTemplate(EM.W)"
        [ngModel]="getValue(EM.W)"
        [valueColor]="getValueColor(EM.W)"
        [strokeWidth]="8"
        textColor="#000"
      />
      <span class="-mt-15"
        ><i [class]="iconsStyles.getRoleIcon(EM.consumptionType)"></i>
        @if(customFunctions.getDeviceStatus(EM.available, EM.error) !==
        "ONLINE"){<span class="text-xs italic">{{
          customFunctions.getDeviceStatus(EM.available, EM.error)
        }}</span
        >}<br /><span>EM {{ EM.deviceNo }}</span></span
      >
    </div>
    }
  </div>
</p-panel>
